import React from "react";
import { CONTACT } from "../i18n/translations";

const WhatsAppButton = () => {
  const href = `https://wa.me/${CONTACT.whatsapp}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float-btn"
      aria-label="WhatsApp"
      className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1FBA57] shadow-xl shadow-black/20 flex items-center justify-center transition-all duration-300 hover:scale-110"
    >
      <svg viewBox="0 0 32 32" className="w-7 h-7 fill-white" aria-hidden="true">
        <path d="M19.11 17.39c-.28-.14-1.64-.81-1.9-.9-.25-.09-.44-.14-.63.14-.19.28-.72.9-.88 1.08-.16.19-.33.21-.61.07-.28-.14-1.18-.43-2.25-1.38-.83-.74-1.39-1.65-1.55-1.93-.16-.28-.02-.43.12-.57.12-.12.28-.33.42-.49.14-.16.19-.28.28-.47.09-.19.05-.35-.02-.49-.07-.14-.63-1.52-.86-2.08-.23-.56-.46-.49-.63-.5h-.54c-.19 0-.49.07-.75.35s-.98.96-.98 2.34 1 2.72 1.14 2.91c.14.19 1.96 3 4.75 4.21.66.29 1.18.46 1.58.59.66.21 1.26.18 1.74.11.53-.08 1.64-.67 1.88-1.32.23-.65.23-1.21.16-1.32-.07-.12-.26-.19-.54-.33zM16 3C8.82 3 3 8.82 3 16c0 2.26.59 4.46 1.72 6.41L3 29l6.75-1.77A12.9 12.9 0 0 0 16 29c7.18 0 13-5.82 13-13S23.18 3 16 3zm0 23.5c-2.02 0-4-.53-5.74-1.54l-.41-.24-4 1.05 1.07-3.9-.27-.4A10.54 10.54 0 0 1 5.5 16C5.5 10.21 10.21 5.5 16 5.5S26.5 10.21 26.5 16 21.79 26.5 16 26.5z" />
      </svg>
    </a>
  );
};

export default WhatsAppButton;
